module.exports = __webpack_public_path__ + "static/media/plus.61e15d0c.svg";